module.exports = ".field {\n  margin-top: 5px; }\n\n.table > thead > tr > th {\n  padding: 3px !important; }\n\n.modal-header {\n  padding: 5px !important; }\n\n#Newadd {\n  margin: 30px auto; }\n\n#ServiceMismatch {\n  margin: 30px auto; }\n\n#alertPopup {\n  margin: 30px auto; }\n\n#currentDetails {\n  margin: 30px auto; }\n\n#contractDetailsEdit {\n  margin: 30px auto; }\n\n#ContractExtension {\n  margin: 30px auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/service-contract/service-contract.component.scss
// module id = ./client/app/service-contract/service-contract.component.scss
// module chunks = main